import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import InicioSesion from "./pages/InicioSesion";
import Servicios from "./pages/Servicios";
import Contacto from "./pages/Contacto";
import Nosotros from "./pages/Nosotros";
import Oficinas from "./pages/Oficinas";
import Aliados from "./pages/Aliados";
import Inicio from "./pages/Inicio";
import InitialLoader from "./components/InitialLoader";
import PageTransition from "./components/motion/PageTransition";
import "./App.scss";

const AnimatedRoutes = () => {
	const location = useLocation();

	return (
		<AnimatePresence exitBeforeEnter>
			<PageTransition key={location.pathname}>
				<Switch location={location}>
					<Route path="/inicio_sesion" component={InicioSesion} />
					<Route path="/servicios" component={Servicios} />
					<Route path="/contacto" component={Contacto} />
					<Route path="/nosotros" component={Nosotros} />
					<Route path="/oficinas" component={Oficinas} />
					<Route path="/aliados" component={Aliados} />
					<Route exact path="/" component={Inicio} />
					<Route
						path="*"
						render={() => {
							return "No encontrada";
						}}
					/>
				</Switch>
			</PageTransition>
		</AnimatePresence>
	);
};

const App = () => {
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const loaderTimeout = setTimeout(() => {
			setIsLoading(false);
		}, 850);

		return () => clearTimeout(loaderTimeout);
	}, []);

	return (
		<BrowserRouter>
			<InitialLoader isVisible={isLoading} />
			<AnimatedRoutes />
		</BrowserRouter>
	);
};

export default App;
